/** Where My Profile lives. */
export const myProfilePath = '/site-management/my-profile'

/** The API's own profile of the caller: GET reads it, PATCH changes the fields sent. */
export const myProfileApi = '/site-management/v1/me'

/** Site Management's part of "Download my data": the caller's files here. */
export const myDataApi = '/site-management/v1/me/data'

/** What the caller must fill in on My Profile after signing in. */
export const myPendingPromptsApi = '/site-management/v1/me/pending'
